module.exports = __webpack_public_path__ + "static/media/modify-icon.f7e27a3b.svg";